<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { Sidebar, TopBar } from '../components/';
import { useStudyStore } from '@/stores/study';
import { useDashboardStore } from '@/stores/dashboard';
import ProgressSpinner from 'primevue/progressspinner';
import { useRouter, useRoute } from 'vue-router';
import { routeConstants } from '@/utils';

const studyStore = useStudyStore();
const dashboardStore = useDashboardStore();
const router = useRouter();
const route = useRoute();

const isMobile = ref(window.matchMedia('(max-width: 768px)').matches || history.state.hideSidebar);

onMounted(() => {
  (async () => {
    await studyStore.getStudies();
    if (route.fullPath === '/dash') {
      if (studyStore.selectedStudy?.longitudinal) {
        router.push({
          name: routeConstants.CASES.name
        });
      } else {
        router.push({
          name: routeConstants.ENTRIES.name
        });
        return { name: routeConstants.ENTRIES.name }; 
      }
    }
  })();
});

const showSidebar = computed(() =>
  (!(studyStore.selectedStudy?.flags?.spRedirect && !studyStore.studyPermissions?.manageInvest && !studyStore.studyPermissions?.editCases))
);

const sidebarVisible = computed(() => showSidebar.value && !isMobile.value);
</script>

<template>
  <div class="dashboard-shell">
    <TopBar :has-sidebar="sidebarVisible" />
    <div class="dashboard">
      <div class="drawer"
        :style="{ width: dashboardStore.sidebarWidth }"
        v-if="sidebarVisible">
        <Sidebar />
      </div>
      <div class="container" :class="{ 'spRedirect' : !showSidebar }"><RouterView /></div>
    </div>
  </div>
  <div class="dashboard-progress" v-if="studyStore.studyLoader.isLoading">
    <ProgressSpinner strokeWidth="4" />
  </div>
</template>

<style scoped lang="scss">
// The top bar spans the full width above both columns, so the shell stacks and the
// sidebar/content row takes whatever height is left.
.dashboard-shell {
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
}
.dashboard {
    display: flex;
    flex: 1;
    min-height: 0;
}
.drawer {
    flex-shrink: 0;
    overflow: hidden;
    height: 100%;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    transition: width 0.2s ease;
}
.container {
    background-color: hsl(0, 0%, 98%);
    height: 100%;
    // Fill whatever the drawer leaves behind; min-width lets wide content scroll
    // instead of stretching the container.
    flex: 1;
    min-width: 0;
}
.spRedirect {
  :deep(.entry-root) {
    display: flex;
    justify-content: center;
  }
}
.dashboard-progress {
  display: flex;
  align-items: center;
  height: 100vh;
  width: 100%;
  justify-content: center;
}
</style>
